import React from 'react'
  import { MDXTag } from '@mdx-js/tag'


  import DefaultLayout from "/Users/psteele/bigstuffedanimal/src/components/layout.js";
import { Link } from 'gatsby';
import Layout from '../components/layout';
import Hero from '../components/hero';
import CompareButton from '../utils/api';
const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = DefaultLayout;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)} components={components}>


      <CompareButton />
           </MDXTag>;
  }

}
MDXContent.isMDXComponent = true;
export const _frontmatter = {};
      